import { connect } from 'react-redux'
import { selectSelectedTicketIds } from 'selectors/ticket_list/base'
import { selectCurrentConversationsById } from 'ducks/tickets/selectors'
import { selectCurrentUserIsAdminOrOwner } from 'ducks/currentUser/selectors'
import { isDeleted } from 'ducks/tickets/utils/state'
import BulkActionBarView from 'components/ConversationList/Header/TitleBar/BulkActionBar'

export const select = state => {
  const selectedTicketIds = selectSelectedTicketIds(state)
  const byId = selectCurrentConversationsById(state)
  return {
    selectedCount: selectedTicketIds.length,
    conversationIds: selectedTicketIds,
    showDeleteButton:
      selectCurrentUserIsAdminOrOwner(state) ||
      selectedTicketIds.some(id => {
        const ticket = byId[id]
        return ticket && !isDeleted(ticket)
      }),
  }
}

export default connect(select)(BulkActionBarView)
